import React, { useEffect, useRef } from "react";

const BasicInput = ({ col, required, label, handleChange }) => {
  const inputRef = useRef(null);

  return (
    <div className={`col-md-${col} col-sm-12`} style={{ display: "flex" }}>
      <div className="input-type-style" style={{ display: "flex" }}>
        <input
          onChange={(e) => {
            handleChange(inputRef);
          }}
          id="input1"
          ref={inputRef}
          className={"input-style"}
        />
        <label
          htmlFor={"input1"}
          className={`input-label-style ${required && "required"} `}
        >
          {label}
        </label>
      </div>
    </div>
  );
};
export default BasicInput;
